import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OrderForm from './OrderForm';
import { fetchWithCorpId } from '../utils/api';
import PageHeader from './ui/PageHeader';
import { FormLoading } from './ui/formkit';

function OrderFormScreen({ mode, onSuccess, onCancel }) {
  const { id } = useParams();
  const isEdit = mode === 'edit';
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(isEdit);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      if (mode === 'edit' && id) {
        setLoading(true);
        try {
          const data = await fetchWithCorpId(`/order/${id}`);
          setOrderData(data);
        } catch (err) {
          console.error('Error fetching order:', err);
          setError('Failed to load order data');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [mode, id]);

  return (
    <div className="page-container">
      <PageHeader
        backTo="/on/orders"
        backLabel="Back to Orders"
        title={isEdit ? 'Edit order' : 'New order'}
      />
      <div className="card" style={{ maxWidth: '880px' }}>
        <div className="card-body">
          {loading && <FormLoading label="Loading order…" />}
          {!loading && error && (
            <div className="alert error" role="alert">{error}</div>
          )}
          {!loading && !error && (
            <OrderForm
              mode={mode}
              initialData={orderData}
              onSuccess={onSuccess}
              onCancel={onCancel}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default OrderFormScreen;
